import React from "react"
import {
  ReactUseState,
  IsSearchingContext,
  GridInitializedContext,
} from "../../../../components/Context"

// TODO:API確定後、responseの型に変更
export const SearchResultContext = React.createContext<any[] | undefined>([])

/**
 * 受注配車パターン入力のProvider
 */
export const ZyutyuHaisyaPatternListProvider: React.FC<{
  isSearching: ReactUseState<boolean>
  gridInitialized: ReactUseState<boolean>
  SearchResult: Array<Object> | undefined
}> = (props) => {
  return (
    <IsSearchingContext.Provider value={props.isSearching}>
      <SearchResultContext.Provider value={props.SearchResult}>
        <GridInitializedContext.Provider value={props.gridInitialized}>
          {props.children}
        </GridInitializedContext.Provider>
      </SearchResultContext.Provider>
    </IsSearchingContext.Provider>
  )
}
